export default {
  TAKING: 'TAKING',
  DECLARING: 'DECLARING',
  THROWING: 'THROWING',
  COUNTING: 'COUNTING',
  DEALING_CARDS: 'DEALING_CARDS',
};
